module.exports = __webpack_public_path__ + "img/arreglalo_logo_300.c0761ee9.png";